<template>
    <div>
      
        <div style="position:fixed;bottom:0;left:0;width:100%;min-height:50px;z-index:1000;" 
        class="rounded-t-xl shadow-xl bg-white p-1 " 
        >
            <div class="row justify-content-around">
              <div class="col-2 text-center ">
                <a href="#countdown">
                  <i class="fas fa-heart text-2xl p-1"></i>
                  <!-- <span class="typcn typcn-home text-2xl p-1"></span> -->
                  <p class="text-xs" style="font-size:10px;">Undangan</p>
                </a>
              </div>
              <div class="col-2 text-center">
                <a href="#mempelai">
                  <i class="fas fa-user-friends text-2xl p-1"></i>
                  <!-- <span class="typcn typcn-group text-2xl p-1"></span> -->
                  <p class="text-xs" style="font-size:10px;">Mempelai</p>
                </a>
              </div>
              <div class="col-2 text-center">
                <a href="#peta">
                  <i class="fas fa-map-marked text-2xl p-1"></i>
                  <!-- <span class="typcn typcn-map text-2xl p-1"></span> -->
                  <p class="text-xs" style="font-size:10px;">Peta</p>
                </a>
              </div>
                <div class="col-2 text-center">
                  <a href="#galery">
                    <i class="fas fa-camera-retro text-2xl p-1"></i>
                    <!-- <span class="typcn typcn-image text-2xl p-1"></span> -->
                    <p class="text-xs" style="font-size:10px;">Galery</p>
                  </a>
              </div>
               <div class="col-2 text-center">
                 <a href="#comment">
                   <i class="fas fa-comments text-2xl p-1"></i>
                  <!-- <span class="typcn typcn-pin text-2xl p-1"></span> -->
                  <p class="text-xs" style="font-size:10px;">Wishes</p>
                 </a>
              </div>
            </div>
        </div>
        <!-- MUSIK BUTTON -->
          <button type="button" @click="playAudio()"
           style="position:fixed;top:10%;right:10px;z-index:1000;border:1px solid white;" 
                class="btn btn-sm btn-dark  rounded-circle">
             <span class="typcn anim" :class="play?'typcn-media-play':'typcn-media-pause'"></span>
        </button>
        
          <audio id="audio1" src="https://undangan.officialapp.website/files/bensound-romantic.mp3"></audio>
    </div>
</template>
<script>
export default{
  props:['particle'],
  data(){
    return{
      play:true
    }
  },
  methods: {
    playAudio(){
      var audio = document.getElementById("audio1");
      this.play=!this.play;
      if(!this.play){
        audio.play();
      }else{
        audio.pause();
        audio.currentTime = 0;
      }
    }
  },
  mounted() {
    let that=this
    if(this.$store.state.data.interact==0){
      this.$router.push('/')
    }else{
      that.playAudio();
    }
    // document.addEventListener('click',function(){
    //   if(interack==0){
    //     that.playAudio();
    //     interack++;
    //   }
    // })
  },
}
</script>
<style>
a:link {
  color:rgb(235, 137, 153);
}
a:visited  {
  color:rgb(235, 137, 153);
}
a:hover {
  color:orange;
}
a:active {
  color:orange;
}
</style>